import { emitPrerenderReady, isPrerenderBuild } from '@/utils/prerender'

/**
 * For public views with no async Firestore bootstrapping.
 * Async views should call emitPrerenderReady() themselves after data loads.
 */
export default {
  mounted() {
    if (!isPrerenderBuild()) return
    this.$nextTick(() => emitPrerenderReady())
  },
}
